import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../shared/base.service';
import { Dealer } from './dealer.model';

@Injectable({
    providedIn: 'root'
})

export class DealerService extends BaseService {

    public getDealers(idToken: string, searchParams: any, pageSize: number, pageIndex: number) {
        let queryParams = new HttpParams();
        queryParams = this.appendQueryParam(queryParams, "dealer-name", searchParams.dealerName);
        queryParams = this.appendQueryParam(queryParams, "last-name", searchParams.contactLastName);
        queryParams = this.appendQueryParam(queryParams, "first-name", searchParams.contactFirstName);
        queryParams = this.appendQueryParam(queryParams, "email", searchParams.contactEmail);
        queryParams = this.appendQueryParam(queryParams, "dealer-id", searchParams.dealerId);
        queryParams = this.appendQueryParam(queryParams, "per-page", pageSize);
        queryParams = this.appendQueryParam(queryParams, "page", pageIndex + 1);

        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/dealers`, { headers, params: queryParams });
    }

    public getDealer(idToken: string, id: number) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/dealer/${id}`, { headers });
    }

    public addDealer(idToken: string, dealer: Dealer) {
        const body = JSON.stringify(dealer);
        const headers = this.getHeaders(idToken);
        return this.httpClient.post(`${this.backendDomain}/dealer`, body, { headers });
    }

    public updateDealer(idToken: string, dealer: Dealer) {
        const body = JSON.stringify(dealer);
        const headers = this.getHeaders(idToken);
        return this.httpClient.put(`${this.backendDomain}/dealer/${dealer.id}`, body, { headers });
    }

    public inactivateDealer(idToken: string, id: number) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.put(`${this.backendDomain}/dealer/inactivate/${id}`, {}, { headers });
    }

    public reactivateDealer(idToken: string, id: number) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.put(`${this.backendDomain}/dealer/reactivate/${id}`, {}, { headers });
    }

    public deleteDealer(idToken: string, id: number) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.delete(`${this.backendDomain}/dealer/${id}`, { headers });
    }

    public getDealerNames(idToken: string, includeAeroStarDynamics?:boolean, includeInactivated?: boolean) {
        let queryParams = new HttpParams();
        queryParams = this.appendQueryParam(queryParams, "include-aerostar-dynamics", includeAeroStarDynamics);
        queryParams = this.appendQueryParam(queryParams, "include-inactivated", includeInactivated);
        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/dealer-names`, { headers, params: queryParams });
    }
}